import { getMobileApp } from './mobileAppRegistry';
import { getSession, getEnabledServices, updateSession } from './sessionDB';

export function isServiceEnabled(service, services = getEnabledServices()) {
  const value = services?.[service];
  return value === true || (value !== null && typeof value === 'object' && Object.keys(value).length > 0);
}

let nextId = 0;
const pending = new Map();
function nativeRequest(action, payload = {}) {
  const bridge = window.KaryaServices;
  if (!bridge?.postMessage) return Promise.resolve(null);
  bridge.onmessage = ({ data }) => {
    try {
      const result = JSON.parse(data);
      pending.get(result.id)?.(result);
    } catch { /* Ignore unrelated native messages. */ }
  };
  return new Promise(resolve => {
    const id = String(++nextId);
    const timer = setTimeout(() => finish(null), 3000);
    const finish = result => {
      clearTimeout(timer);
      pending.delete(id);
      resolve(result);
    };
    pending.set(id, finish);
    try { bridge.postMessage(JSON.stringify({ id, action, ...payload })); }
    catch { finish(null); }
  });
}

export async function initializeMobileSession() {
  const result = await nativeRequest('bootstrap');
  if (result?.session?.accessToken) {
    // Preserve the original expiry; importing a session must not extend its lifetime.
    localStorage.removeItem('wp_session');
    sessionStorage.removeItem('wp_session');
    updateSession({ ...result.session, loginAttendanceStage: 'complete' });
  }
}

export async function openServiceApp(service) {
  if (!isServiceEnabled(service) || getMobileApp()?.service === service) return false;
  const session = getSession();
  if (!session.accessToken) return false;
  const result = await nativeRequest('openService', { service, session });
  return result?.opened === true;
}
